import React from 'react';

import { Route, useRouteMatch } from 'react-router-dom';

import { MainCard } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/MainCard';

export const GanttChartCardModel = () => {
    const { path } = useRouteMatch();
    return <Route path={`${path}/card-:cardId`} render={() => <MainCard />} />;
};
